import {coreApi} from './core'

const waybillService = {
    getAll: async () => coreApi.get('/waybill'),
    paginate: async (offset) => coreApi.get(`/waybill/${offset}`),
    getById: async (id) => coreApi.get(`/waybill?id=${id}`),
    getCompanyById: async (id) => coreApi.get(`/waybill/company?companyid=${id}`),
    getContractById: async (id) => coreApi.get(`/waybill/contract/${id}`),
    create: async (data) => coreApi.post('/waybill', data),
    update: async (data) => coreApi.put('/waybill', data),
    delete: async (id) => coreApi.delete(`/waybill/${id}`),
    return: async (id, cause) => coreApi.get(`/waybill/return/${id}/${cause}`),
}

export {waybillService}
